import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e6e159a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" It looks like there isn't any data for this type of comparison - This could be due to the date period selection or data not being present. Please go to ")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Segment Groups", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" to add some segment data. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" It looks like there isn't any data for the ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" segment - This could be due to the date period selection or data not being present. Please go to ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Segment Groups", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" to add some segment data. ")
const _hoisted_8 = { class: "columns is-multiline" }
const _hoisted_9 = { class: "column is-full" }
const _hoisted_10 = { class: "box" }
const _hoisted_11 = ["value", "disabled"]
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Columns", -1))
const _hoisted_16 = {
  key: 2,
  class: "tw-mt-4"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "columns is-multiline" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-header" }
const _hoisted_21 = { class: "card-header-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Explore", -1))
const _hoisted_23 = { class: "card-content" }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-content" }
const _hoisted_27 = { class: "content has-text-grey has-text-centered" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There's no data to show", -1))
const _hoisted_29 = { class: "modal-card" }
const _hoisted_30 = { class: "modal-card-head" }
const _hoisted_31 = { class: "modal-card-title" }
const _hoisted_32 = { class: "modal-card-body" }
const _hoisted_33 = { class: "modal-card-foot" }

import { ref, computed, watch, onMounted, ComputedRef } from "vue";
import { storeToRefs } from "pinia";
//Stores
import { UseProgramStore } from "../../Modules/State/Stores/ProgramStore";
import { UseSegmentComparisonStore } from "../../Modules/State/Stores/SegmentComparisonStore";
import { UseDateStore } from "../../Modules/State/Stores/DateStore";
//Helpers
import { UseUrlBuilder } from "../../Helper/Stateful/UseUrlBuilder";
import { UseTaxonomyHelper } from "../../Helper/Stateful/UseTaxonomyHelper";
import { UseColumnsHelper } from "../../Helper/Functional/UseColumnsHelper";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";
import { UseArrayHelper } from "../../Helper/Functional/UseArrayHelper";
import { SegmentComparisonLoading } from "./Hooks/SegmentComparisonLoading";

//Static Data
import { StaticColumnData } from "../../StaticData/StaticColumnData";
import { StaticChartData } from "../../StaticData/StaticChartData";

//Hooks
import { UseSegmentComparisonState } from "./Hooks/UseSegmentComparisonState";
import { SegmentComparisonChannelDropdowns } from "./Hooks/SegmentComparisonChannelDropdowns";
import { SegmentComparisonTableAndChartaData } from "./Hooks/SegmentComparisonTableAndChartData";
import { SegmentComparisonDataManipulation } from "./Hooks/SegmentComparisonDataManipulation";

//Components
import OuterSection from "../../Elements/OuterSection.vue";
import MetaBreadcrumb from "../../Modules/Meta/Breadcrumb.vue";
import SegTable from "../../Modules/SegmentComparison/Table/Table.vue";
import SegChart from "../../Modules/SegmentComparison/Chart/Chart.vue";
import ExportData from "../../Modules/Pieces/ExportData.vue";
import ColumnSelection from "../../Modules/Pieces/ColumnSelection.vue";
//Types

import {
  TAllTableHeaderValues,
  IChartObject,
  TChartData,
  IGeTAllTableHeaders,
  TChartExportDataNew,
} from "../../../typings/DataFetching";

//Reactive store data

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

//Framework
const { getCurrentProgram } = storeToRefs(UseProgramStore());
const { getAllFetchUrls, getTopName, getBottomName, getSegmentMetric } = storeToRefs(
  UseSegmentComparisonStore()
);
const {
  setAllFetchUrls,
  setTopName,
  setBottomName,
  setTabularHeaders,
  setSegmentMetric,
  setComparisonMetricLeft,
  setComparisonMetricRight,
} = UseSegmentComparisonStore();

const { getDateFrom, getDateTo } = storeToRefs(UseDateStore());

const { findItemUsingIndex } = UseArrayHelper();

//Handle Tabs
const tabModel = ref(0);

//Taxonomy
const {
  currentTaxonomyInteger,
  taxonomyOne,
  taxonomyTwo,
  taxonomyThree,
  fetchNavigationUrlHandler,
  taxonomyRouteParams,
} = UseTaxonomyHelper();

//Get Taxonomy Level
taxonomyRouteParams();

const getFetchNavigationUrl = computed(() =>
  fetchNavigationUrlHandler("/segment-comparison")
);

const { validateInternalParameter } = UseStringHelper();

//Loading

const { loading, setTableLoading, setChartLoading } = SegmentComparisonLoading();

//Dropdowns

const { dropDownNames, comparisonMetric } = SegmentComparisonChannelDropdowns();

watch(
  dropDownNames,
  (newVal) => {
    if (newVal.length) {
      comparisonMetric.value[0] = newVal[0].tag;
      comparisonMetric.value[1] = newVal[1].tag;
      //Set Top/Left and Bottom/Right Names
      setTopName(newVal[0].title);
      setBottomName(newVal[1].title);
      //Clear data
      metaTabularExportedData.value = [];
    }
  },
  { deep: true }
);

//Build URL
const URLHelperMethod = (tag: string) => {
  return UseUrlBuilder({
    dataSet: tag,
  });
};
const dropdownIteratorHelper = (arr: ComputedRef<{ tag: string; title: string }[]>) => {
  setAllFetchUrls(
    arr.value.map((name) => {
      const builder = URLHelperMethod(`${name.tag}/`);
      return builder.buildFullUrlSegment("table/single", "chart/multi", name.tag);
    })
  );
};
if (dropDownNames.value.length) {
  dropdownIteratorHelper(dropDownNames);
}

watch(
  comparisonMetric,
  (val) => {
    if (val) {
      setComparisonMetricLeft(comparisonMetric.value[0]);
      setComparisonMetricRight(comparisonMetric.value[1]);
      setTopName(
        dropDownNames.value.find(({ tag }) => tag === comparisonMetric.value[0])?.title ||
          ""
      );
      setBottomName(
        dropDownNames.value.find(({ tag }) => tag === comparisonMetric.value[1])?.title ||
          ""
      );
      metaTabularExportedData.value = putItAllTogether(tableData.value);
      chartExportData.value = chartMatched(
        chartData.value,
        comparisonMetric.value[0],
        comparisonMetric.value[1]
      );
    }
  },
  { deep: true }
);

//Get some Data?

const {
  allFetch,
  chartData,
  tableData,
  setChartData,
  setTableData,
} = SegmentComparisonTableAndChartaData();

//Don't have any data? Store it here
const segmentsWithNoData = ref<string[]>([]);

const allFetchHandler = async (
  promiseArray: {
    tag: string;
    table: Promise<{
      data: TAllTableHeaderValues<IGeTAllTableHeaders>[];
      headers: IGeTAllTableHeaders;
    }>;
    chart: Promise<{
      data: TChartData[];
      headers: IGeTAllTableHeaders;
    }>;
  }[]
) => {
  setChartLoading(true);
  setTableLoading(true);
  segmentsWithNoData.value = [];
  const resolvedTableData = [] as {
    tag: string;
    table: TAllTableHeaderValues<IGeTAllTableHeaders>[];
  }[];

  const resolvedChartData = [] as IChartObject[];
  const allPromises = await Promise.all(promiseArray);
  const tableDataResponse = await Promise.all(allPromises).then((res) =>
    res.map(async (v) => ({
      tag: v.tag,
      table: await v.table.then((r) => r.data),
      chart: await v.chart.then((r) => r.data),
    }))
  );
  for await (const item of tableDataResponse) {
    //HERE I will take the empty arrays and add the tag to the segments with no data array. If there is no table data then there will definitely not be any chart data.
    if (!item.table.length) {
      segmentsWithNoData.value = [item.tag, ...segmentsWithNoData.value];
    }
    resolvedTableData.push({ tag: item.tag, table: item.table });
    resolvedChartData.push({ tag: item.tag, chart: item.chart });
  }
  setTableData(resolvedTableData);
  setChartData(resolvedChartData);
  setChartLoading(false);
  setTableLoading(false);
};

onMounted(() => {
  dropdownIteratorHelper(dropDownNames);
  if (dropDownNames.value.length) {
    setTopName(dropDownNames.value[0].title);
    setBottomName(dropDownNames.value[1].title);
  }
});

watch(
  [getAllFetchUrls],
  () => {
    allFetchHandler(allFetch.value);
  },
  { deep: true }
);

//Data manipulation functions
const { chartMatched, putItAllTogether } = SegmentComparisonDataManipulation();

//Chart data
const chartExportData = ref<TChartExportDataNew[]>([] as TChartExportDataNew[]);

watch(chartData, (val) => {
  if (val.length && comparisonMetric.value.length) {
    chartExportData.value = chartMatched(
      val,
      comparisonMetric.value[0],
      comparisonMetric.value[1]
    );
  }
});

const { metrics } = StaticChartData();
const metric = computed({
  get() {
    return getSegmentMetric.value;
  },
  set(metricComputed: string) {
    setSegmentMetric(metricComputed);
  },
});
watch(metric, () => {
  chartExportData.value = chartMatched(
    chartData.value,
    comparisonMetric.value[0],
    comparisonMetric.value[1]
  );
  setChartLoading(false);
});

//Table data
const { columns, sortOrder, sortField } = UseSegmentComparisonState();

const { headers } = StaticColumnData();
const {
  exportAlwaysColumnsList,
  exportSelectedColumnsList,
  exportTabularHeadersList,
  exportTabularColumnsList,
  headersKeyPair,
} = UseColumnsHelper();
const exportAlwaysColumns = computed(() =>
  exportAlwaysColumnsList(currentTaxonomyInteger)
);
const exportSelectedColumns = computed(() =>
  exportSelectedColumnsList(currentTaxonomyInteger, columns, getTopName, getBottomName)
);

const exportTabularColumns = computed(() =>
  exportTabularColumnsList(
    currentTaxonomyInteger,
    headersKeyPair(getTopName, getBottomName)
  )
);
const exportTabularHeaders = computed(() =>
  exportTabularHeadersList(
    currentTaxonomyInteger,
    headersKeyPair(getTopName, getBottomName)
  )
);
const { availableColumns } = StaticColumnData();
const metaTabularExportedData = ref<
  Partial<TAllTableHeaderValues<IGeTAllTableHeaders>>[]
>([]);

watch(tableData, (val) => {
  if (val?.length) {
    metaTabularExportedData.value = putItAllTogether(val);
    setTableLoading(false);
  }
});
onMounted(() => {
  setTabularHeaders(headersKeyPair(getTopName, getBottomName).value);
});

const isColumnModalActive = ref(false);
const tableProps = computed(() => ({
  taxonomy: currentTaxonomyInteger.value,
  sortedTabled: metaTabularExportedData.value,
  sortOrder: sortOrder.value,
  sortField: sortField.value,
  selectedColumns: exportSelectedColumns.value,
}));

//Reset all data on Program or date change
watch([getCurrentProgram, getDateFrom, getDateTo], () => {
  metaTabularExportedData.value = [];
  tableData.value = [];
  chartData.value = [];
  chartExportData.value = [];
  if (dropDownNames.value.length) {
    dropdownIteratorHelper(dropDownNames);
  }
});

//Gatekeeping
const chartDataGoodToGo = computed(() => {
  if (!chartExportData.value.length) return false;
  return chartExportData.value.some((src) => !!src.bottom || !!src.top);
});

//Notifications
const comparisonDown = computed(() => {
  if (segmentsWithNoData.value.length) {
    const comparisonKeys = comparisonMetric.value.findIndex((k) =>
      segmentsWithNoData.value.includes(k)
    );
    return comparisonKeys !== -1
      ? findItemUsingIndex(
          dropDownNames.value,
          comparisonMetric.value,
          "tag",
          comparisonKeys
        )?.title || ""
      : "";
  }
  return "";
});

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_o_notification = _resolveComponent("o-notification")!
  const _component_o_select = _resolveComponent("o-select")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_tab_item = _resolveComponent("o-tab-item")!
  const _component_o_tabs = _resolveComponent("o-tabs")!
  const _component_o_modal = _resolveComponent("o-modal")!

  return (_openBlock(), _createBlock(OuterSection, null, {
    default: _withCtx(() => [
      _createVNode(_component_o_loading, {
        active: _unref(loading),
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
        "full-page": false
      }, null, 8, ["active"]),
      (!chartExportData.value.length && !metaTabularExportedData.value.length && !_unref(loading))
        ? (_openBlock(), _createBlock(_component_o_notification, {
            key: 0,
            variant: "warning",
            "aria-close-label": "Close notification",
            role: "alert",
            class: "tw-mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_router_link, { to: "/segment-groups" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(chartDataGoodToGo) && _unref(comparisonDown)?.length && !_unref(loading))
        ? (_openBlock(), _createBlock(_component_o_notification, {
            key: 1,
            variant: "warning",
            "aria-close-label": "Close notification",
            role: "alert",
            class: "tw-mb-4"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("strong", null, _toDisplayString(_unref(comparisonDown)), 1),
              _hoisted_5,
              _createVNode(_component_router_link, { to: "/segment-groups" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(MetaBreadcrumb, {
              "taxonomy-one": _unref(taxonomyOne),
              "taxonomy-two": _unref(taxonomyTwo),
              "taxonomy-three": _unref(taxonomyThree),
              "base-url": 'segment-comparison'
            }, null, 8, ["taxonomy-one", "taxonomy-two", "taxonomy-three"]),
            (_unref(dropDownNames).length)
              ? (_openBlock(), _createBlock(_component_o_field, {
                  key: 0,
                  grouped: "",
                  "group-multiline": "",
                  class: "tw-mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_field, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_select, {
                              modelValue: _unref(comparisonMetric)[0],
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(comparisonMetric)[0]) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropDownNames), (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: option.tag,
                                    key: option.tag,
                                    disabled: option.tag === _unref(comparisonMetric)[1]
                                  }, _toDisplayString(option.title), 9, _hoisted_11))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_o_field, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_select, {
                              modelValue: _unref(comparisonMetric)[1],
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(comparisonMetric)[1]) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropDownNames), (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: option.tag,
                                    key: option.tag,
                                    disabled: option.tag === _unref(comparisonMetric)[0]
                                  }, _toDisplayString(option.title), 9, _hoisted_12))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_o_field, {
                      grouped: "",
                      "group-multiline": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_13, [
                              _createElementVNode("button", {
                                class: "button",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (isColumnModalActive.value = true)),
                                disabled: 
                      tabModel.value !== 1 ||
                      (!metaTabularExportedData.value.length && !_unref(chartDataGoodToGo))
                    
                              }, [
                                _createVNode(_component_o_icon, { icon: "table-row-height" }),
                                _hoisted_15
                              ], 8, _hoisted_14)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(ExportData, {
                              "available-columns": _unref(exportTabularColumns),
                              "selected-columns": _unref(exportSelectedColumns),
                              "always-selected-columns": _unref(exportAlwaysColumns),
                              "column-headers": _unref(exportTabularHeaders),
                              "report-name": 'Tabular Data Export',
                              "exportable-data": metaTabularExportedData.value,
                              "order-data-by": _unref(sortField),
                              "order-data-direction": _unref(sortOrder),
                              disabled: !metaTabularExportedData.value.length && !_unref(chartDataGoodToGo)
                            }, null, 8, ["available-columns", "selected-columns", "always-selected-columns", "column-headers", "exportable-data", "order-data-by", "order-data-direction", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (metaTabularExportedData.value.length && _unref(chartDataGoodToGo) && !_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_o_tabs, {
              animated: false,
              modelValue: tabModel.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tabModel).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_o_tab_item, {
                  label: "Visual",
                  icon: "chart-scatter-plot-hexbin",
                  value: 0
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_field, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_o_select, {
                          modelValue: _unref(metric),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(metric) ? (metric).value = $event : null))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(metrics), (option, value) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: value,
                                key: value
                              }, _toDisplayString(option), 9, _hoisted_17))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chartExportData.value, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `sm-${value.name}`,
                          class: "column is-full-mobile is-one-third-desktop"
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("header", _hoisted_20, [
                              _createElementVNode("p", _hoisted_21, _toDisplayString(value.name), 1),
                              (_unref(currentTaxonomyInteger) < 4)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: _unref(getFetchNavigationUrl) + _unref(validateInternalParameter)(value.name),
                                    class: "card-header-icon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_o_icon, {
                                        icon: "chevron-right",
                                        size: "is-small"
                                      }),
                                      _hoisted_22
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              value
                                ? (_openBlock(), _createBlock(SegChart, {
                                    key: 0,
                                    "chart-export-data": value,
                                    "channel-name": value.name,
                                    "bottom-name": _unref(getBottomName),
                                    "top-name": _unref(getTopName),
                                    metric: _unref(metric)
                                  }, null, 8, ["chart-export-data", "channel-name", "bottom-name", "top-name", "metric"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_o_tab_item, {
                  label: "Tabular",
                  icon: "table",
                  value: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(SegTable, { table: _unref(tableProps) }, null, 8, ["table"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : (!chartExportData.value.length && !_unref(loading) && !_unref(chartDataGoodToGo))
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_o_icon, {
                        icon: "emoticon-sad",
                        size: "is-large"
                      })
                    ]),
                    _hoisted_28
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
      _createVNode(_component_o_modal, {
        active: isColumnModalActive.value,
        "onUpdate:active": _cache[8] || (_cache[8] = ($event: any) => ((isColumnModalActive).value = $event)),
        "has-modal-card": "",
        "trap-focus": "",
        "aria-role": "dialog",
        "aria-modal": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("header", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, "Selected Columns (" + _toDisplayString(_unref(columns).length) + ")", 1)
            ]),
            _createElementVNode("section", _hoisted_32, [
              _createVNode(ColumnSelection, {
                "available-columns": _unref(availableColumns),
                "selected-columns": _unref(columns),
                "onUpdate:selected-columns": _cache[6] || (_cache[6] = ($event: any) => (_isRef(columns) ? (columns).value = $event : null)),
                "column-headers": _unref(headers)
              }, null, 8, ["available-columns", "selected-columns", "column-headers"])
            ]),
            _createElementVNode("footer", _hoisted_33, [
              _createElementVNode("button", {
                class: "button",
                type: "button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (isColumnModalActive.value = false))
              }, " Close ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _: 1
  }))
}
}

})